import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { AlloyButton, Popup } from 'cat-ecommerce-alloy';
import ContactDealerPopup from '../../../ContactDealerPopup';
import SaveToListButton from '../../../buttons/SaveToListButton';
import cx from 'classnames';

const ContactDealerActions = ({
  catEntryId,
  isGuest,
  showSaveToList,
  showSmallVariant,
  isIndirectReplacement,
  getCustomizeButton,
  hideDealerButton,
  partNumber
}) => {
  const [t] = useTranslation();
  const contactDealerLabel = t('CONTACT_YOUR_DEALER');
  const contents = (
    <ContactDealerPopup catEntryId={catEntryId} partNumber={partNumber} />
  );

  const initiator = (
    <AlloyButton
      buttonType={showSmallVariant ? 'tertiary' : 'secondary'}
      className={cx('w-100')}
      size={showSmallVariant ? 'dynamic' : 'large'}
    >
      {contactDealerLabel}
    </AlloyButton>
  );

  return (
    <div
      className={cx({
        'row align-items-center': !showSmallVariant
      })}
    >
      {!hideDealerButton && (
        <div
          className={cx({
            'py-2 col-12 col-lg-auto pe-lg-0': !showSmallVariant,
            'py-1': showSmallVariant
          })}
        >
          <Popup
            className="mt-2"
            contents={contents}
            id="pdp__contact-dealer-popup"
            initiator={initiator}
          />
        </div>
      )}
      {isIndirectReplacement && getCustomizeButton && getCustomizeButton()}
      {showSaveToList && !showSmallVariant && (
        <div className="col-12 col-lg py-2">
          <SaveToListButton isGuest={isGuest} />
        </div>
      )}
    </div>
  );
};

ContactDealerActions.propTypes = {
  catEntryId: PropTypes.string,
  partNumber: PropTypes.string,
  isGuest: PropTypes.bool,
  showSaveToList: PropTypes.bool,
  showSmallVariant: PropTypes.bool,
  isIndirectReplacement: PropTypes.bool,
  hideDealerButton: PropTypes.bool,
  getCustomizeButton: PropTypes.func
};

export default ContactDealerActions;
